import React, { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'

import Form from '../../../../../../components/Form'
import InputsPresetEditFormContent from './InputsPresetEditFormContent'

import { usePurifiedFormik } from '../../../../../../hooks/formHooks/usePurifiedFormik'
import { transformValuesToBE } from './formatters'

import { selectedPartnershipSelector } from '../../../../../../modules/selectors/partnerships'
import {
  getSroiInputsPresetSelector,
  updateSroiInputsPresetErrorSelector,
  updateSroiInputsPresetIsLoadingSelector,
  updateSroiInputsPresetWasUpdatedSelector
} from '../../../../../../modules/selectors/socialReturnOnInvestment'
import {
  clearUpdateSroiInputsPreset,
  updateSroiInputsPreset
} from '../../../../../../modules/actions/socialReturnOnInvestment'

import { SROI_INPUTS_PRESET_EDIT } from '../../../../../../constants/forms'
import { validationSchema } from './validation'
import { getInitialValues } from './fields'

const InputsPresetEditForm = () => {
  const dispatch = useDispatch()

  const selectedPartnership = useSelector(selectedPartnershipSelector)
  const selectedPartnershipId = selectedPartnership?.id

  const sroiInputsPresetWasUpdated = useSelector(updateSroiInputsPresetWasUpdatedSelector)
  const sroiInputsPreset = useSelector(getSroiInputsPresetSelector)

  const onSubmit = useCallback(
    values => {
      const transformedValues = transformValuesToBE(values)

      dispatch(
        updateSroiInputsPreset(
          {
            partnership: selectedPartnershipId
          },
          {
            inputs_preset: transformedValues
          }
        )
      )
    },
    [dispatch, selectedPartnershipId]
  )

  const initialValues = useMemo(() => {
    return getInitialValues(sroiInputsPreset)
  }, [sroiInputsPreset])

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
    enableReinitialize: true
  })

  const purifiedFormik = usePurifiedFormik(formik)

  const clearHandler = useCallback(() => {
    dispatch(clearUpdateSroiInputsPreset())
  }, [dispatch])

  return (
    <Form
      formik={purifiedFormik}
      formName={SROI_INPUTS_PRESET_EDIT}
      successSubmit={sroiInputsPresetWasUpdated}
      errorSelector={updateSroiInputsPresetErrorSelector}
      isLoadingSelector={updateSroiInputsPresetIsLoadingSelector}
      clearHandler={clearHandler}
    >
      <InputsPresetEditFormContent formik={formik} />
    </Form>
  )
}

export default InputsPresetEditForm
